var React = require('react');
var moment = require('moment');
var _ = require('lodash');
var cx = require('classnames');
import Day from './Day.jsx';

//moment.locale('en', { week : { dow : 6, doy: 6} });
/**
 * Responsible of returing a <tr> element with the week's days cells
 */
export default class Week extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    getDays() {
        var days = [];
        _.times(7, (n) => {
            var day = moment.utc(this.props.firstDayOfWeek).add(n, 'days');
            var dayOfWeek = moment.utc(this.props.firstDayOfWeek).add(n, 'days').day();
            var weekOfYear = moment.utc(this.props.firstDayOfWeek).week();
            // If day is of this month
            if (day.month() == this.props.month.month()) {
                days.push(
                    <Day 
                        key={n} 
                        day={day} 
                        interactive={this.props.interactive}
                        refresh={this.props.refresh}
                        selector={this.props.selector}
                        static={this.props.static}
                    />
                );
            } else {
                days.push(
                    <td className="day old" key={n}></td>
                );
            }
        });
        return days;
    }

    render() {
        var week = moment.utc(this.props.firstDayOfWeek).week();
        return (
            <tr className="week-row" key={'w'+week}>{this.getDays()}</tr>
        );
    }
}
